import React from "react";

export const Body = () => {
  return (
    <main className="container__body">
      <section className="container__academy">
        <h1>DESARROLLADORA FRONTEND</h1>

        <h2>Experiencia laboral</h2>

        <div>
          <h4>Capgemini</h4>
          <p>Octubre 2024 - Actualidad</p>
          <p>Desarrolladora Junior</p>
          <span>Colombia</span>
        </div>
        <hr />

        <div>
          <h4>Freelance</h4>
          <p>Agosto 2023 - Septiembre 2024</p>
          <p>Desarrolladora Frontend</p>
          <p>
            Desarrollé la maquetación de la landing page y diferentes
            componentes usando SvelteKit y Tailwind. Colaboré en la realización
            de un proyecto usando React, Java Springboot y PostgreSQL. Colaboro
            en un proyecto usando Next, TypeScript, Material UI, GraphQL.
          </p>
          <span>Colombia</span>
        </div>
        <hr />

        <div>
          <h4>IT Globers</h4>
          <p>01 Abril 2023 - 30 Mayo 2023</p>
          <p>Desarrolladora Frontend Trainee</p>
          <p>
            Aprendi a usar VTEX IO nativo y a realizar componentes custom usando
            React y Typescript y hacer su respectiva conexion.
          </p>
          <span>Colombia</span>
        </div>
        <hr />

        <div>
          <h4>Arte-Laser corte y grabado</h4>
          <p>julio 2017 - marzo 2019</p>
          <p>Auxiliar de diseño gráfico</p>
          <p>
            Apoyé en la sección de diseño gráfico trabajando con Adobe
            Illustrator y CorelDRAW.
          </p>
          <span>Medellin-Colombia</span>
        </div>

        <h2>Educación</h2>
        <div>
          <h4>Figma</h4>
          <a
            href="https://drive.google.com/file/d/1ppJHt6_rkd4T27m3NfUXTkvGzjW9FYI2/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
            className="projects__links"
          >
            Platzi
          </a>
          <p>Noviembre 2023</p>
          <br />
          <p>Figma: Tecnicas avanzadas de diseño</p>
        </div>
        <hr />

        <div>
          <h4>Figma</h4>
          <a
            href="https://cursos.desafiolatam.com/certificates/dxmcwir6cw"
            target="_blank"
            rel="noreferrer"
            className="projects__links"
          >
            Academia Desafio Latam
          </a>
          <p>Noviembre 2023</p>
          <br />
          <p>Curso - Taller Figma</p>
        </div>
        <hr />

        <div>
          <h4>Java y SpringBoot</h4>
          <a
            href="https://www.credential.net/664bbd8b-26e9-47bd-aae4-da277c17bc14#gs.178i2k"
            target="_blank"
            rel="noreferrer"
            className="projects__links"
          >
            Laboratoria+
          </a>
          <p>Septiembre - Noviembre 2023</p>
          <br />
          <p>Java, POO, PostrgreSQL, SpringBoot, JUnit-Testing, Swagger</p>
        </div>
        <hr />

        <div>
          <h4>Analisis de datos</h4>
          <a
            href="https://www.credential.net/47192a9e-3a35-41d5-a612-299b9c8dbfe9#gs.6m3096"
            target="_blank"
            rel="noreferrer"
            className="projects__links"
          >
            Laboratoria+
          </a>
          <p>Julio 2023</p>
          <br />
          <p>Manejo y visualización de datos (SQL, Power BI)</p>
        </div>
        <hr />

        <div>
          <h4>SQL</h4>
          <a
            href="https://www.credential.net/a187f127-e347-4550-b326-540fefdd5412#gs.1ryl2v"
            target="_blank"
            rel="noreferrer"
            className="projects__links"
          >
            Laboratoria+ / Globant
          </a>
          <p>Junio 2023</p>
          <br />
          <p>
            Los fundamentos de las bases de datos, donde aprendí la creación de
            tablas y consultas de datos.
          </p>
        </div>
        <hr />

        <div>
          <h4>Desarrolladora Frontend</h4>
          <a
            href="https://drive.google.com/file/d/163Y6-QaAXyNhAtadOmlbqDYZosupTEPb/view"
            target="_blank"
            rel="noreferrer"
            className="projects__links"
          >
            Laboratoria
          </a>
          <p>Julio 2022 - Diciembre 2022</p>
          <br />
          <p>
            Bootcamp de aprendizaje intensivo donde se desarrolla habilidades
            técnicas y blandas que capacitan para trabajar en la industria Tech.
          </p>
          <span>Colombia</span>
        </div>
        <hr />

        <div>
          <h4>UDEMY</h4>
          <ul>
            <li>
              <a
                href="https://udemy-certificate.s3.amazonaws.com/pdf/UC-8bbd6b96-1e4a-477d-b2ff-00fdaf91a915.pdf"
                className="projects__links"
              >
                React JS desde cero! Hooks, Redux, context, firebase y más!
                (Ignacio Bluuweb)
              </a>
            </li>
            <li>React: De cero a experto / hooks y MERN (Fernando Herrera)</li>
            <li>
              Boostrap 5 desde cero + HTML, CSS, Flexbox, Sass, GIT, JS (Ignacio
              Bluuweb)
            </li>
          </ul>
        </div>
        <hr />

        <div>
          <h4>Medica Veterinaria</h4>
          <p>Universidad de La Salle</p>
          <span>Caldas(Antioquia)-Colombia</span>
        </div>
      </section>
    </main>
  );
};
